<template>
	<div v-if="basketItems.length" class="cart-icon"></div>
</template>
<script>

import { mapState } from 'vuex'
import { mapMutations } from 'vuex'
import axios from 'axios'

export default {

	mounted() {
		this.loadItems()
	},

  computed: {
    ...mapState([
      'basketItems',
    ]),
	},

  methods: {

		...mapMutations([
      'updateBasketItems',
    ]),

    loadItems() {
      axios.post('/basket/items',
      {},
      {
        emulateJSON: true,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        }
      }
      ).then((response) => {
				this.updateBasketItems(response.data)
      })

    },

  }

}

</script>
